import BiMap from 'bidirectional-map';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

export enum RingType {
  ENGRAVED = 'ENGRAVED',
  NOT_ENGRAVED = 'NOT_ENGRAVED',
}

export const getEngravingKey = (ip: boolean | null | string) => {
  return ip ? RingType.ENGRAVED : RingType.NOT_ENGRAVED;
};

export type RingVariantType = {
  variantId: Partial<Record<ShopifyStore, string>>;
  checkoutUrl: Partial<Record<ShopifyStore, string>>;
  fastDelivery?: boolean;
  SKU?: string;
  misc?: Record<MiscRingCheckoutTypes, any>;
};

// Rare Sizing Kit Shopify Map
export const RareSizingKitShopifyMap: Record<
  ShopifyStore,
  Record<string, string | number>
> = process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
  ? {
      [ShopifyStore.IN]: {
        variantId: '43833414910022',
        shopifyVariantId: 'gid://shopify/ProductVariant/43833414910022',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/43833414910022:1?channel=buy_button',
        price: 0,
      },
      [ShopifyStore.AE]: {
        variantId: '62134118777203',
        shopifyVariantId: 'gid://shopify/ProductVariant/62134118777203',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/62134118777203:1?channel=buy_button',
        price: 0,
      },
      [ShopifyStore.ROW]: {
        variantId: '43522202304572',
        shopifyVariantId: 'gid://shopify/ProductVariant/43522202304572',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/43522202304572:1?channel=buy_button',
        price: 0,
      },
      [ShopifyStore.US]: {
        variantId: '42309890932832',
        shopifyVariantId: 'gid://shopify/ProductVariant/42309890932832',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/42309890932832:1?channel=buy_button',
        price: 0,
      },
      [ShopifyStore.CA]: {
        variantId: '42309890932832',
        shopifyVariantId: 'gid://shopify/ProductVariant/42309890932832',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/42309890932832:1?channel=buy_button',
        price: 0,
      },
      [ShopifyStore.EU]: {
        variantId: '56326679527798',
        shopifyVariantId: 'gid://shopify/ProductVariant/56326679527798',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326679527798:1?channel=buy_button',
        price: 0,
      },
      [ShopifyStore.AU]: {
        variantId: '56326679527798',
        shopifyVariantId: 'gid://shopify/ProductVariant/56326679527798',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326679527798:1?channel=buy_button',
        price: 0,
      },
      [ShopifyStore.GB]: {
        variantId: '56326679527798',
        shopifyVariantId: 'gid://shopify/ProductVariant/56326679527798',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326679527798:1?channel=buy_button',
        price: 0,
      },
      [ShopifyStore.SA]: {},
      [ShopifyStore.MX]: {},
      [ShopifyStore.ZA]: {},
      [ShopifyStore.JP]: {},
    }
  : {
      [ShopifyStore.IN]: {
        variantId: '43833414910022',
        shopifyVariantId: 'gid://shopify/ProductVariant/43833414910022',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/43833414910022:1?channel=buy_button',
        price: 0,
      },
      [ShopifyStore.AE]: {
        variantId: '62134118777203',
        shopifyVariantId: 'gid://shopify/ProductVariant/62134118777203',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/62134118777203:1?channel=buy_button',
        price: 0,
      },
      [ShopifyStore.ROW]: {
        variantId: '43522202304572',
        shopifyVariantId: 'gid://shopify/ProductVariant/43522202304572',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/43522202304572:1?channel=buy_button',
        price: 0,
      },
      [ShopifyStore.US]: {
        variantId: '42309890932832',
        shopifyVariantId: 'gid://shopify/ProductVariant/42309890932832',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/42309890932832:1?channel=buy_button',
        price: 0,
      },
      [ShopifyStore.CA]: {
        variantId: '42309890932832',
        shopifyVariantId: 'gid://shopify/ProductVariant/42309890932832',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/42309890932832:1?channel=buy_button',
        price: 0,
      },
      [ShopifyStore.AU]: {
        variantId: '56326679527798',
        shopifyVariantId: 'gid://shopify/ProductVariant/56326679527798',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326679527798:1?channel=buy_button',
        price: 0,
      },
      [ShopifyStore.EU]: {
        variantId: '56326679527798',
        shopifyVariantId: 'gid://shopify/ProductVariant/56326679527798',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326679527798:1?channel=buy_button',
        price: 0,
      },
      [ShopifyStore.GB]: {
        variantId: '56326679527798',
        shopifyVariantId: 'gid://shopify/ProductVariant/56326679527798',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326679527798:1?channel=buy_button',
        price: 0,
      },
      [ShopifyStore.SA]: {},
      [ShopifyStore.MX]: {},
      [ShopifyStore.ZA]: {},
      [ShopifyStore.JP]: {},
    };

// PowerPlugs Bundle for RARE - includes AFib, Cycle and Ovulation Pro, Tesla Powerplug, and M1 Lite collectively
export const RarePowerPlugsBundleShopifyMap: Record<
  ShopifyStore,
  Record<string, string | number>
> = process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
  ? {
      [ShopifyStore.IN]: {
        variantId: '43833452134470',
        shopifyVariantId: 'gid://shopify/ProductVariant/43833452134470',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/43833452134470:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.AE]: {
        variantId: '62134128509299',
        shopifyVariantId: 'gid://shopify/ProductVariant/62134128509299',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/62134128509299:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.ROW]: {
        variantId: '43522201714748',
        shopifyVariantId: 'gid://shopify/ProductVariant/43522201714748',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/43522201714748:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.US]: {
        variantId: '42309886836832',
        shopifyVariantId: 'gid://shopify/ProductVariant/42309886836832',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/42309886836832:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.CA]: {
        variantId: '42309886836832',
        shopifyVariantId: 'gid://shopify/ProductVariant/42309886836832',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/42309886836832:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.EU]: {
        variantId: '56326717735286',
        shopifyVariantId: 'gid://shopify/ProductVariant/56326717735286',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326717735286:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.AU]: {
        variantId: '56326717735286',
        shopifyVariantId: 'gid://shopify/ProductVariant/56326717735286',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326717735286:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.GB]: {
        variantId: '56326717735286',
        shopifyVariantId: 'gid://shopify/ProductVariant/56326717735286',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326717735286:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.SA]: {},
      [ShopifyStore.MX]: {},
      [ShopifyStore.ZA]: {},
      [ShopifyStore.JP]: {},
    }
  : {
      [ShopifyStore.IN]: {
        variantId: '43833452134470',
        shopifyVariantId: 'gid://shopify/ProductVariant/43833452134470',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/43833452134470:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.AE]: {
        variantId: '62134128509299',
        shopifyVariantId: 'gid://shopify/ProductVariant/62134128509299',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/62134128509299:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.ROW]: {
        variantId: '43522201714748',
        shopifyVariantId: 'gid://shopify/ProductVariant/43522201714748',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/43522201714748:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.US]: {
        variantId: '42309886836832',
        shopifyVariantId: 'gid://shopify/ProductVariant/42309886836832',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/42309886836832:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.CA]: {
        variantId: '42309886836832',
        shopifyVariantId: 'gid://shopify/ProductVariant/42309886836832',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/42309886836832:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.EU]: {
        variantId: '56326717735286',
        shopifyVariantId: 'gid://shopify/ProductVariant/56326717735286',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326717735286:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.AU]: {
        variantId: '56326717735286',
        shopifyVariantId: 'gid://shopify/ProductVariant/56326717735286',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326717735286:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.GB]: {
        variantId: '56326717735286',
        shopifyVariantId: 'gid://shopify/ProductVariant/56326717735286',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326717735286:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.SA]: {},
      [ShopifyStore.MX]: {},
      [ShopifyStore.ZA]: {},
      [ShopifyStore.JP]: {},
    };

export enum RareColors {
  DESERT_ROSE = 'DESERT_ROSE',
  DESERT_SNOW = 'DESERT_SNOW',
  DUNE = 'DUNE',
}

// Stable color order array to prevent hydration issues
export const RARE_COLOR_ORDER: RareColors[] = [
  RareColors.DESERT_ROSE,
  RareColors.DESERT_SNOW,
  RareColors.DUNE,
];

// Rare product price data structure
export const RarePriceData: Record<
  ShopifyStore,
  Record<
    RareColors,
    { striked_price: number; price: number; tax_incl: boolean }
  >
> = {
  [ShopifyStore.IN]: {
    [RareColors.DESERT_ROSE]: {
      striked_price: 189999,
      price: 189999,
      tax_incl: true,
    },
    [RareColors.DESERT_SNOW]: {
      striked_price: 219999,
      price: 219999,
      tax_incl: true,
    },
    [RareColors.DUNE]: { striked_price: 189999, price: 189999, tax_incl: true },
  },
  [ShopifyStore.ROW]: {
    [RareColors.DESERT_ROSE]: {
      striked_price: 1799,
      price: 1799,
      tax_incl: false,
    },
    [RareColors.DESERT_SNOW]: {
      striked_price: 1999,
      price: 1999,
      tax_incl: false,
    },
    [RareColors.DUNE]: { striked_price: 1799, price: 1799, tax_incl: false },
  },
  [ShopifyStore.US]: {
    [RareColors.DESERT_ROSE]: {
      striked_price: 1799,
      price: 1799,
      tax_incl: false,
    },
    [RareColors.DESERT_SNOW]: {
      striked_price: 1999,
      price: 1999,
      tax_incl: false,
    },
    [RareColors.DUNE]: { striked_price: 1799, price: 1799, tax_incl: false },
  },
  [ShopifyStore.SA]: {
    [RareColors.DESERT_ROSE]: {
      striked_price: 7799,
      price: 7799,
      tax_incl: false,
    },
    [RareColors.DESERT_SNOW]: {
      striked_price: 8599,
      price: 8599,
      tax_incl: false,
    },
    [RareColors.DUNE]: { striked_price: 7799, price: 7799, tax_incl: false },
  },
  [ShopifyStore.MX]: {
    [RareColors.DESERT_ROSE]: {
      striked_price: 38999,
      price: 38999,
      tax_incl: false,
    },
    [RareColors.DESERT_SNOW]: {
      striked_price: 42999,
      price: 42999,
      tax_incl: false,
    },
    [RareColors.DUNE]: { striked_price: 38999, price: 38999, tax_incl: false },
  },
  [ShopifyStore.CA]: {
    [RareColors.DESERT_ROSE]: {
      striked_price: 2499,
      price: 2499,
      tax_incl: false,
    },
    [RareColors.DESERT_SNOW]: {
      striked_price: 2799,
      price: 2799,
      tax_incl: false,
    },
    [RareColors.DUNE]: { striked_price: 2499, price: 2499, tax_incl: false },
  },
  [ShopifyStore.AE]: {
    [RareColors.DESERT_ROSE]: {
      striked_price: 6599,
      price: 6599,
      tax_incl: false,
    },
    [RareColors.DESERT_SNOW]: {
      striked_price: 7299,
      price: 7299,
      tax_incl: false,
    },
    [RareColors.DUNE]: { striked_price: 6599, price: 6599, tax_incl: false },
  },
  [ShopifyStore.GB]: {
    [RareColors.DESERT_ROSE]: {
      striked_price: 1599,
      price: 1599,
      tax_incl: true,
    },
    [RareColors.DESERT_SNOW]: {
      striked_price: 1799,
      price: 1799,
      tax_incl: true,
    },
    [RareColors.DUNE]: { striked_price: 1599, price: 1599, tax_incl: true },
  },
  [ShopifyStore.EU]: {
    [RareColors.DESERT_ROSE]: {
      striked_price: 1839,
      price: 1839,
      tax_incl: true,
    },
    [RareColors.DESERT_SNOW]: {
      striked_price: 2039,
      price: 2039,
      tax_incl: true,
    },
    [RareColors.DUNE]: { striked_price: 1839, price: 1839, tax_incl: true },
  },
  [ShopifyStore.AU]: {
    [RareColors.DESERT_ROSE]: {
      striked_price: 2999,
      price: 2999,
      tax_incl: true,
    },
    [RareColors.DESERT_SNOW]: {
      striked_price: 3349,
      price: 3349,
      tax_incl: true,
    },
    [RareColors.DUNE]: { striked_price: 2999, price: 2999, tax_incl: true },
  },
  [ShopifyStore.ZA]: {
    [RareColors.DESERT_ROSE]: {
      striked_price: 39999,
      price: 39999,
      tax_incl: true,
    },
    [RareColors.DESERT_SNOW]: {
      striked_price: 44999,
      price: 44999,
      tax_incl: true,
    },
    [RareColors.DUNE]: { striked_price: 39999, price: 39999, tax_incl: true },
  },
  [ShopifyStore.JP]: {
    [RareColors.DESERT_ROSE]: {
      striked_price: 288000,
      price: 288000,
      tax_incl: true,
    },
    [RareColors.DESERT_SNOW]: {
      striked_price: 325000,
      price: 325000,
      tax_incl: true,
    },
    [RareColors.DUNE]: { striked_price: 288000, price: 288000, tax_incl: true },
  },
};

export const RareColorNameImages: Record<
  RareColors,
  Record<string, string | null | React.ReactNode>
> = {
  [RareColors.DESERT_ROSE]: {
    image: 'web_v2/rare-buy/renders/desert-rose/1-dr.png/w_400',
    shop: `web_v2/shop/rare/desert-rose.png`,
    name: 'Desert Rose',
    tag: null,
  },
  [RareColors.DESERT_SNOW]: {
    image: 'web_v2/rare-buy/renders/desert-snow/1-ds.png/w_400',
    shop: `web_v2/shop/rare/deser-snow.png`,
    name: 'Desert Snow',
    tag: null,
  },
  [RareColors.DUNE]: {
    image: 'web_v2/rare-buy/renders/dune/1-dn.png/w_400',
    shop: `web_v2/shop/rare/dune.png`,
    name: 'Dune',
    tag: null,
  },
};

export const RareColorNameLargeImages: Record<
  RareColors,
  Record<string, string | null>
> = {
  [RareColors.DESERT_ROSE]: {
    image: 'web_v2/illustrations/desert_rose_tracking.png/w_1000',
    name: 'Desert Rose',
    tag: null,
  },
  [RareColors.DESERT_SNOW]: {
    image: 'web_v2/illustrations/desert_snow_tracking.png/w_1000',
    name: 'Desert Snow',
    tag: null,
  },
  [RareColors.DUNE]: {
    image: 'web_v2/illustrations/dune_tracking.png/w_1000',
    name: 'Dune',
    tag: null,
  },
};

// UHX Lifetime for RARE - separate from regular UHX Year1/Year2 system
export const RareUhxLifetimeShopifyMap: Record<
  ShopifyStore,
  Record<string, string | number>
> = process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
  ? {
      [ShopifyStore.IN]: {
        variantId: '43833416941638',
        shopifyVariantId: 'gid://shopify/ProductVariant/43833416941638',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/43833416941638:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.AE]: {
        variantId: '62134123495795',
        shopifyVariantId: 'gid://shopify/ProductVariant/62134123495795',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/62134123495795:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.ROW]: {
        variantId: '43522199814204',
        shopifyVariantId: 'gid://shopify/ProductVariant/43522199814204',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/43522199814204:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.US]: {
        variantId: '42309887918176',
        shopifyVariantId: 'gid://shopify/ProductVariant/42309887918176',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/42309887918176:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.CA]: {
        variantId: '42309887918176',
        shopifyVariantId: 'gid://shopify/ProductVariant/42309887918176',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/42309887918176:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.EU]: {
        variantId: '56326701613430',
        shopifyVariantId: 'gid://shopify/ProductVariant/56326701613430',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326701613430:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.AU]: {
        variantId: '56326701613430',
        shopifyVariantId: 'gid://shopify/ProductVariant/56326701613430',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326701613430:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.GB]: {
        variantId: '56326701613430',
        shopifyVariantId: 'gid://shopify/ProductVariant/56326701613430',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326701613430:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.SA]: {},
      [ShopifyStore.MX]: {},
      [ShopifyStore.ZA]: {},
      [ShopifyStore.JP]: {},
    }
  : {
      [ShopifyStore.IN]: {
        variantId: '43833416941638',
        shopifyVariantId: 'gid://shopify/ProductVariant/43833416941638',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/43833416941638:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.AE]: {
        variantId: '62134123495795',
        shopifyVariantId: 'gid://shopify/ProductVariant/62134123495795',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/62134123495795:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.ROW]: {
        variantId: '43522199814204',
        shopifyVariantId: 'gid://shopify/ProductVariant/43522199814204',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/43522199814204:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.US]: {
        variantId: '42309887918176',
        shopifyVariantId: 'gid://shopify/ProductVariant/42309887918176',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/42309887918176:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.CA]: {
        variantId: '42309887918176',
        shopifyVariantId: 'gid://shopify/ProductVariant/42309887918176',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/42309887918176:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.EU]: {
        variantId: '56326701613430',
        shopifyVariantId: 'gid://shopify/ProductVariant/56326701613430',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326701613430:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.AU]: {
        variantId: '56326701613430',
        shopifyVariantId: 'gid://shopify/ProductVariant/56326701613430',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326701613430:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.GB]: {
        variantId: '56326701613430',
        shopifyVariantId: 'gid://shopify/ProductVariant/56326701613430',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/56326701613430:1?channel=buy_button',
        price: 0, // Included with RARE purchase
      },
      [ShopifyStore.SA]: {},
      [ShopifyStore.MX]: {},
      [ShopifyStore.ZA]: {},
      [ShopifyStore.JP]: {},
    };

export const FrontendBackendRareNameMap = new BiMap({
  [RareColors.DESERT_ROSE]: 'rare_desert_rose',
  [RareColors.DESERT_SNOW]: 'rare_desert_snow',
  [RareColors.DUNE]: 'rare_dune',
});

// Map of RARE Ring Product IDs per store for hero product type detection
export const RareRingAndRelatedProductsIdMap =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? {
        [ShopifyStore.IN]: [
          'gid://shopify/Product/7815889289286', // RARE dessert rose rings IN
          'gid://shopify/Product/7815889748038', // RARE dune rings IN
          'gid://shopify/Product/7815890042950', // RARE dessert snow rings IN
          'gid://shopify/Product/7961932398662', // RARE sizing kit IN
        ],
        [ShopifyStore.AE]: [
          'gid://shopify/Product/15185477435763', // RARE dessert rose rings IN
          'gid://shopify/Product/15185478189427', // RARE dune rings IN
          'gid://shopify/Product/15185478517107', // RARE dessert snow rings IN
          'gid://shopify/Product/15185478680947', // RARE sizing kit AE
        ],
        [ShopifyStore.ROW]: [
          'gid://shopify/Product/7958184198204', // RARE dessert rose rings IN
          'gid://shopify/Product/7958185803836', // RARE dune rings IN
          'gid://shopify/Product/7958186426428', // RARE dessert snow rings IN
          'gid://shopify/Product/8675030761532', // RARE sizing kit ROW
        ],
        [ShopifyStore.US]: [
          'gid://shopify/Product/7330073149536', // RARE dessert rose rings IN
          'gid://shopify/Product/7330073673824', // RARE dune rings IN
          'gid://shopify/Product/7330073739360', // RARE dessert snow rings IN
          'gid://shopify/Product/7512955617376', // RARE sizing kit US
        ],
        [ShopifyStore.EU]: [
          'gid://shopify/Product/15120462020982', // RARE dessert rose rings IN
          'gid://shopify/Product/15120467722614', // RARE dune rings IN
          'gid://shopify/Product/7815890042950', // RARE dessert snow rings IN
          'gid://shopify/Product/15120468836726', // RARE sizing kit EU
        ],
        [ShopifyStore.GB]: [
          'gid://shopify/Product/15120462020982', // RARE dessert rose rings IN
          'gid://shopify/Product/15120467722614', // RARE dune rings IN
          'gid://shopify/Product/7815890042950', // RARE dessert snow rings IN
          'gid://shopify/Product/15120468836726', // RARE sizing kit GB
        ],
        [ShopifyStore.AU]: [
          'gid://shopify/Product/15120462020982', // RARE dessert rose rings IN
          'gid://shopify/Product/15120467722614', // RARE dune rings IN
          'gid://shopify/Product/7815890042950', // RARE dessert snow rings IN
          'gid://shopify/Product/15120468836726', // RARE sizing kit AU
        ],
        [ShopifyStore.CA]: [
          'gid://shopify/Product/7330073149536', // RARE dessert rose rings IN
          'gid://shopify/Product/7330073673824', // RARE dune rings IN
          'gid://shopify/Product/7330073739360', // RARE dessert snow rings IN
          'gid://shopify/Product/7512955617376', // RARE sizing kit US
        ],
        [ShopifyStore.SA]: [
          'gid://shopify/Product/15120462020982', // RARE dessert rose rings IN
          'gid://shopify/Product/15120467722614', // RARE dune rings IN
          'gid://shopify/Product/7815890042950', // RARE dessert snow rings IN
          'gid://shopify/Product/15120468836726', // RARE sizing kit EU
        ],

        [ShopifyStore.MX]: [
          'gid://shopify/Product/15120462020982', // RARE dessert rose rings IN
          'gid://shopify/Product/15120467722614', // RARE dune rings IN
          'gid://shopify/Product/7815890042950', // RARE dessert snow rings IN
          'gid://shopify/Product/15120468836726', // RARE sizing kit EU
        ],
        [ShopifyStore.ZA]: [
          'gid://shopify/Product/15120462020982', // RARE dessert rose rings IN
          'gid://shopify/Product/15120467722614', // RARE dune rings IN
          'gid://shopify/Product/7815890042950', // RARE dessert snow rings IN
          'gid://shopify/Product/15120468836726', // RARE sizing kit EU
        ],
        [ShopifyStore.JP]: [
          'gid://shopify/Product/15120462020982', // RARE dessert rose rings IN
          'gid://shopify/Product/15120467722614', // RARE dune rings IN
          'gid://shopify/Product/7815890042950', // RARE dessert snow rings IN
          'gid://shopify/Product/15120468836726', // RARE sizing kit EU
        ],
      }
    : {
        // STAGING - using same IDs as production
        [ShopifyStore.IN]: [
          'gid://shopify/Product/7815889289286', // RARE rings IN
          'gid://shopify/Product/7961932398662', // RARE sizing kit IN
        ],
        [ShopifyStore.AE]: [
          'gid://shopify/Product/15185477435763', // RARE rings AE
          'gid://shopify/Product/15185478680947', // RARE sizing kit AE
        ],
        [ShopifyStore.ROW]: [
          'gid://shopify/Product/7958184198204', // RARE rings ROW
          'gid://shopify/Product/8675030761532', // RARE sizing kit ROW
        ],
        [ShopifyStore.US]: [
          'gid://shopify/Product/7330073149536', // RARE rings US
          'gid://shopify/Product/7512955617376', // RARE sizing kit US
        ],
        [ShopifyStore.EU]: [
          'gid://shopify/Product/15120462020982', // RARE rings EU
          'gid://shopify/Product/15352596300150', // RARE sizing kit EU
        ],
        [ShopifyStore.GB]: [
          'gid://shopify/Product/15120462020982', // RARE rings GB
          'gid://shopify/Product/15352596300150', // RARE sizing kit GB
        ],
        [ShopifyStore.AU]: [
          'gid://shopify/Product/15120462020982', // RARE rings AU
          'gid://shopify/Product/s', // RARE sizing kit AU
        ],
        [ShopifyStore.CA]: [
          'gid://shopify/Product/7330073149536', // RARE rings CA
          'gid://shopify/Product/7512955617376', // RARE sizing kit CA
        ],
        [ShopifyStore.SA]: [
          'gid://shopify/Product/15120462020982', // RARE rings AU
          'gid://shopify/Product/s', // RARE sizing kit AU
        ],
        [ShopifyStore.MX]: [
          'gid://shopify/Product/15120462020982', // RARE rings AU
          'gid://shopify/Product/s', // RARE sizing kit AU
        ],
        [ShopifyStore.ZA]: [
          'gid://shopify/Product/15120462020982', // RARE rings AU
          'gid://shopify/Product/s', // RARE sizing kit AU
        ],
        [ShopifyStore.JP]: [
          'gid://shopify/Product/15120462020982', // RARE rings AU
          'gid://shopify/Product/s', // RARE sizing kit AU
        ],
      };
// Helper map for API responses (without 'rare_' prefix)
export const ApiToFrontendRareColorMap: Record<string, RareColors> = {
  desert_rose: RareColors.DESERT_ROSE,
  desert_snow: RareColors.DESERT_SNOW,
  dune: RareColors.DUNE,
};

// Helper function to convert API color identifier to frontend format
export const getFullRareColorIdentifier = (
  apiColorIdentifier: string,
): string | null => {
  const rareColor = ApiToFrontendRareColorMap[apiColorIdentifier];
  if (rareColor) {
    return FrontendBackendRareNameMap.get(rareColor) as string;
  }
  return null;
};

// Helper function to check if a color identifier is a rare ring
export const isRareRingColor = (colorIdentifier: string): boolean => {
  // Check if it's already in rare format
  if (colorIdentifier.startsWith('rare_')) {
    return true;
  }
  // Check if it's an API format rare color
  return colorIdentifier in ApiToFrontendRareColorMap;
};

export enum RingChargerType {
  OG = 'OG',
  DARK_MOON = 'DARK_MOON',
  TRAVEL_CHARGER = 'TRAVEL_CHARGER',
}

export enum MiscRingCheckoutTypes {
  BETTER_HELP_CHECKOUT = 'BETTER_HELP_CHECKOUT',
}

// Import environment-based discount configuration
export { getRareDiscountConfig } from '../discountConfig';
